export const RANGE_0_6 = 0;
export const RANGE_6_12 = 1;
export const RANGE_12_18 = 2;
export const RANGE_18_24 = 3;
